// iter-386u-t — Landing page for the sidebar "Project Ledger" entry.
// If the vendor has exactly one assigned project, redirect straight to
// that ledger. Otherwise show a picker so they can pick a project.
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { BookText, ChevronRight, Briefcase } from 'lucide-react';
import Layout from '@/components/Layout';
import { API } from '@/App';

export default function VendorProjectLedgerIndex() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/projects`);
        const list = Array.isArray(r.data) ? r.data : [];
        setProjects(list);
        if (list.length === 1) {
          navigate(`/vendor/project-ledger/${list[0].id}?tab=overview`, { replace: true });
        }
      } catch (err) {
        toast.error(err.response?.data?.detail || 'Could not load projects');
        setProjects([]);
      }
    })();
  }, [navigate]);

  if (projects === null) {
    return <Layout><div className="flex items-center justify-center h-96 text-stone-400">Loading projects…</div></Layout>;
  }

  return (
    <Layout>
      <div className="max-w-3xl mx-auto p-6 space-y-4">
        <div className="flex items-center gap-2">
          <BookText size={22} className="text-purple-600" />
          <h1 className="text-xl font-bold text-stone-900">Project Ledger</h1>
        </div>
        <p className="text-sm text-stone-500">Pick a project to open its ledger.</p>

        {projects.length === 0 ? (
          <div className="apple-card p-8 text-center text-stone-400 italic">
            You are not assigned to any active projects yet.
          </div>
        ) : (
          <div className="space-y-2">
            {projects.map((p) => (
              <Link
                key={p.id}
                to={`/vendor/project-ledger/${p.id}?tab=overview`}
                className="apple-card p-4 flex items-center justify-between hover:bg-stone-50 transition-colors"
                data-testid={`ledger-project-item-${p.id}`}
              >
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-purple-100 text-purple-700"><Briefcase size={18} /></div>
                  <div>
                    <p className="font-semibold text-stone-900">{p.name}</p>
                    <p className="text-xs text-stone-500">{p.status || '—'}</p>
                  </div>
                </div>
                <ChevronRight size={18} className="text-stone-400" />
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
